import { IMsalAuthService } from "./msal/msalAuthService";

export function httpAuthInterceptor($q, $injector/*, msalAuthService: IMsalAuthService*/) {

    const interceptor = {

        response(response: any): any {
            return response;
        },

        responseError(rejection: any): any {

            if (rejection.status === 401 && $injector.get('$state').$current.name !== 'login') {
                $injector.get('MsalAuthService').msal().logoutRedirect();
                //msalAuthService.msal().logoutRedirect();
            }

            return $q.reject(rejection);
        }
    };

    return interceptor;
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/httpAuthInterceptor.ts
 **/